import { RentalPortalApplicantProfileDocuments } from '../RentalPortalApplicantProfileDocuments'
import { RentalPortalApplicantProfileTabOverview } from '../RentalPortalApplicantProfileTabOverview'
import { RentalPortalApplicantProfileUpdates } from '../RentalPortalApplicantProfileUpdates'

import { APPLICANT_PROFILE_TAB } from './RentalPortalApplicantProfileTabs.constants'

export function getApplicantProfileTabContent(activeTabId) {
  switch (activeTabId) {
    case APPLICANT_PROFILE_TAB.documents:
      return <RentalPortalApplicantProfileDocuments />
    case APPLICANT_PROFILE_TAB.overview:
      return <RentalPortalApplicantProfileTabOverview />
    case APPLICANT_PROFILE_TAB.updates:
      return <RentalPortalApplicantProfileUpdates />
    default:
      return null
  }
}
